<template>
  <div v-show="getMessages">
    <div id="home" class="_3qlW9">
      <div class="_3BqNZ">
        <div data-asset-intro-image="true" class="_2Uo0Z " style="transform: scale(1); opacity: 1; background-image: url('imgs/advance-logo.png');"></div>
          <div class="_2MnNk" style="opacity: 1; transform: translateY(0px);">
            <h1 class="iHhHL">Advance Management</h1>
                <div class="_1Y6o1">
                  <div class="_3zFlu"></div>
                    <div class="_3cK8a">
                      <span data-icon="laptop" class="">
                        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18" width="21" height="18">
                          <path fill="#9DA3A5" d="M10.426 14.235a.767.767 0 0 1-.765-.765c0-.421.344-.765.765-.765s.765.344.765.765-.344.765-.765.765zM4.309 3.529h12.235v8.412H4.309V3.529zm12.235 9.942c.841 0 1.522-.688 1.522-1.529l.008-8.412c0-.842-.689-1.53-1.53-1.53H4.309c-.841 0-1.53.688-1.53 1.529v8.412c0 .841.688 1.529 1.529 1.529H1.25c0 .842.688 1.53 1.529 1.53h15.294c.841 0 1.529-.688 1.529-1.529h-3.058z"></path>
                        </svg>
                      </span>
                      <div class="_1lrYJ">Realize aqui suas ligações.</div>
                    </div>
                  </div>
                </div>
            </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "ChatMensagem",
  data(){
    return {}
  },
  methods: {},
  computed: {
    ...mapGetters(["getMessages"]),
  }
};

</script>

<style>
._3qlW9 {
    align-items:center;
    -webkit-flex-grow:1;
    flex-grow:1;
    -webkit-justify-content:center;
    justify-content:center;
    /* z-index:1; */
    display:flex;
}

._3qlW9:after {
    bottom:0;
    height:0
}

._3qlW9 a {
    color:#07bc4c
}

._2Uo0Z {
    width:256px;
    height:255px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: fixed;
    background-position: 50% 50%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.iHhHL {
    color:#4b5961;
    font-size:36px;
    font-weight:300;
    text-align: center;
}

._1ClcF {
    font-size:14px;
    line-height:20px;
    text-align: center;
}

._3zFlu {
    height:1px;
    margin:20px 0px 20px 0px;
    background-color:#E1E9EB
}

._3cK8a {
    font-size:14px;
    line-height:20px;
    display:-webkit-inline-flex;
    display:inline-flex;
    -webkit-align-items:center;
    align-items:center
}

._1Y6o1 {
    display: table;
    margin: 0 auto;
}

._1lrYJ {
    margin-left:5px;
    margin-right:5px;
}

::-webkit-scrollbar {
    width:6px!important;
    height:6px!important
}

::-webkit-scrollbar-thumb {
    background-color:rgba(0,0,0,.2)
}
::-webkit-scrollbar-track {
    background:rgba(255,255,255,.08)
}
</style>
